import { ApiResponse } from '../api/utils/responseTransform';

export function isMFASessionExpired(response: ApiResponse<unknown>) {
  // Devise has no machine-readable MFA error code; match its explicit unauthenticated response only.
  return (
    response.type === 'error' &&
    response.status === 401 &&
    response.error.errors.some(
      (message) =>
        message === 'You need to sign in or sign up before continuing.' ||
        message === 'Necesitas iniciar sesión o registrarte antes de continuar.'
    )
  );
}

export function getMFAVerificationErrors(response: ApiResponse<unknown>): string[] {
  if (response.type !== 'error' || !response.error.errors.length) {
    return ['Unable to verify your code. Please try again.'];
  }

  return response.error.errors.map((message) =>
    response.status === 401 && message.startsWith('Sorry, incorrect code.')
      ? "Sorry, that code doesn't match. Try again or resend. After 10 failed attempts, your account will be temporarily locked."
      : message
  );
}
